import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

const Login = () => import("@/views/LoginView.vue");
const Dashboard = () => import("@/views/DashboardView.vue");
const CapacitacionCurso = () => import("@/views/CapacitacionCursoView.vue");
const Validador = () => import("@/views/CapacitacionView.vue");

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    { path: "/", redirect: "/login" },
    { path: "/login", name: "Login", component: Login, meta: { guestOnly: true } },
    { path: "/home", name: "Home", component: Dashboard, meta: { requiresAuth: true } },
    {
      // QR impreso → lista pública de participantes del curso
      path: "/capacitacion",
      name: "Capacitacion",
      component: CapacitacionCurso,
      meta: { public: true },
    },
    {
      // Validador por DNI (antes estaba en /capacitacion)
      path: "/validador",
      name: "Validador",
      component: Validador,
      meta: { public: true },
    },
    { path: "*", redirect: "/login" },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    return next();
  }

  const hasToken = !!store.state.token;
  if (to.meta.requiresAuth && !hasToken) {
    return next("/login");
  }
  if (to.meta.guestOnly && hasToken) {
    return next("/home");
  }

  next();
});

export default router;
